import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BlockComponent } from "@components/container-block/block.component";
import { InputComponent } from "@components/input/input.component";
import { TableComponent } from "@components/table/table.component";
import { RaskColumn } from "~app/common/components/table/models/rask-column";
import { Viol3AvtalsobjektComponent } from "../viol3-avtalsobjekt/viol3-avtalsobjekt.component";
import { IViol3ArbetsorderAggregatPreviewContractData, IViol3ContractLinePreviewData } from "../viol3-preview.model";

@Component({
    selector: "rask-viol3-kontrakt",
    templateUrl: "./viol3-kontrakt.component.html",
    styleUrls: ["./viol3-kontrakt.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        InputComponent,
        TableComponent,
        Viol3AvtalsobjektComponent
    ]
})
export class Viol3KontraktComponent {
    @Input() kontraktData: IViol3ArbetsorderAggregatPreviewContractData;

    tableColumns = [
        {
            headerName: "Radnummer",
            field: "contractLineItemNumber",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipComponent: "contractLineItemNumber"
        },
        {
            headerName: "Inmätt hs",
            field: "productIdentifier",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IViol3ContractLinePreviewData, value: string) => row.productName
        },
        {
            headerName: "Måttslag",
            field: "raskMattslag",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Andra Måttslag",
            field: "measuringMethodMayDeviate",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Prislista",
            field: "prisberakning",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Stockmätning krävs",
            field: "stockmatningKravs",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Kvalitetsklassning",
            field: "qualityClassification",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Prioriterad mätmetod",
            field: "prioriteradMatmetod",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Certifiering",
            field: "safetyAndEnvironmentalType",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        }
    ] as RaskColumn[];

    getMeasuringTicketPreview(data: IViol3ArbetsorderAggregatPreviewContractData) {
        return data.measuringTicket?.map(m => m.name).join(", ");
    }
}
